import { render, staticRenderFns } from "./ObjectVideo.vue?vue&type=template&id=0b820812&scoped=true&"
import script from "./ObjectVideo.vue?vue&type=script&lang=js&"
export * from "./ObjectVideo.vue?vue&type=script&lang=js&"
import style0 from "./ObjectVideo.vue?vue&type=style&index=0&id=0b820812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b820812",
  null
  
)

export default component.exports